<template>
  <section class="module narrow over">
		<div class="max-width side-padding">		
			<h2 class="title-medium module-title">Nello stesso repertorio</h2>
			<div class="col-4" v-if="othersInRepertorio.length">
        <article class="album-preview" v-for="album in othersInRepertorio" :key="album.id">
          <router-link :to="'/catalog/' + album.slug" class="no-underline block">
            <div class="album-img-block">
              <img v-if="album.cover.path" :src="album.cover.path" />
              <img v-else src="/themes/caramba/assets/images/album.jpg" />
            </div>
          

            <h1 class="title-small regular">{{ album.artist.name }}</h1>
            <h2 class="title-small light">{{ album.title }}</h2>
            <p class="normal arial">{{ album.artist.category && album.artist.category.name }}</p>
          </router-link>
        </article>
			</div>
      <div v-else>
        <p class="no-results">Non ci sono altri dischi per questo repertorio</p>
      </div>
		</div>
	</section>
</template>

<script>
import {shuffle} from './../utils/utils.js';

export default {
  props: ['record'],

  data() {
    return {
      otherArtistsInRepertorio: []
    }
  },

  created() {
    const hasCategory = this.record.category != null;
    const hasAlbums = hasCategory && this.record.category.albums != null;
    const othersInRepertorio = hasCategory && hasAlbums && this.record.category.albums.filter(album => album.id != this.record.id);
    this.othersInRepertorio = othersInRepertorio && shuffle(othersInRepertorio).slice(0, 4);
  }
}
</script>

<style scoped>
.no-results {
  margin-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/vue/components/AlbumSameRepertorio.vue